<template>
  <div class="text-input" :class="{invalid: invalid !== null}">
    <label>{{label}}</label>

    <div class="input-components">
      <div v-if="prefix" class="prefix" v-html="prefix" tabindex="0" @click="focus"></div>
      <div class="input">
        <textarea v-if="$attrs.type === 'textarea'" v-bind="$attrs" v-on="listeners" ref="input"></textarea>
        <input v-else v-bind="$attrs" v-on="listeners" :style="{textAlign}" ref="input">

        <button v-if="isPassword" class="toggle-password" tabindex="-1" @click="togglePassword">
          <i v-if="passwordVisible" class="fal fa-eye"></i>
          <i v-else class="fal fa-eye-slash"></i>
        </button>
      </div>
      <div v-if="suffix" class="suffix" v-html="suffix" tabindex="0" @click="focus"></div>
    </div>

    <div v-if="invalid !== null" class="error">
      <i class="fas fa-exclamation-circle"></i>
      {{invalid}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextInput',
  inheritAttrs: false,

  props: {
    label: {
      type: String,
      default: null,
      required: false
    },
    invalid: {
      default: null,
      required: false
    },
    prefix: {
      type: String,
      default: null,
      required: false
    },
    suffix: {
      type: String,
      default: null,
      required: false
    },
    textAlign: {
      type: String,
      required: false
    }
  },

  methods: {
    focus () {
      this.$refs.input.focus()
    },

    togglePassword () {
      this.passwordVisible = !this.passwordVisible

      if (this.passwordVisible) {
        this.$attrs.type = 'text'
      } else {
        this.$attrs.type = 'password'
      }
    }
  },

  computed: {
    listeners () {
      return {
        ...this.$listeners,
        input: e => {
          this.$emit('input', e.target.value)
          this.passwordVisible = false
        }
      }
    }
  },

  data () {
    return {
      isPassword: false,
      passwordVisible: false
    }
  },

  mounted () {
    this.isPassword = (this.$attrs.type ?? 'text') === 'password'
  }
}
</script>

<style lang="less" scoped>
@import (reference) '../assets/shared.less';

.text-input {
  display: inline-block;
  width: 100%;

  label {
    color: contrast(@main-color);
    font-family: Rajdhani, sans-serif;
  }

  .input-components {
    .base-input;
    display: flex;
    overflow: hidden;
    padding: 0;

    .prefix,
    .suffix {
      padding: 10px;
      font-size: 15pt;
      background: shade(contrast(@main-color), 87%);
      cursor: default;
      user-select: none;
      color: shade(contrast(@main-color), 50%);
    }

    .input {
      flex: 1;

      input, textarea {
        .base-input;
        border: none;
        background: transparent;
      }
    }
  }

  .toggle-password {
    float: right;
    background: transparent;
    color: contrast(@main-color);
    border: none;
    font-size: 15pt;
    margin: 12px 0px 0px -35px;
    clear: both;
    z-index: 1;
    cursor: pointer;
    position: absolute;
    opacity: 0.4;
    transition: opacity 200ms;
    font-weight: 100;

    &:hover {
      opacity: 1;
    }
  }

  .error {
    color: #ff5f5f;
    padding-left: 8px;
    padding-top: 5px;
  }

  &.invalid {
    label {
      color: #ff5f5f;
    }
    input {
      border-color: #ff5f5f;
    }
  }
}
</style>
